import useWindowDimensions from "./useWindowDimensions";

export const useDeviceDetect = (breakpoints = { tablet: 992, desktop: 1200 }) => {
    const { width } = useWindowDimensions();
    const isMobile = width < breakpoints.tablet;
    const isTablet = width >= breakpoints.tablet && width < breakpoints.desktop;
    const isDesktop = width >= breakpoints.desktop;

    return {
        isMobile,
        isTablet,
        isDesktop,
    };
};
